import {HTTP_BAD_REQUEST} from "./http.error";
import ClientError from "./client.error";

export default class BadRequestError extends ClientError {
    /**
     * Constructor
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(message, response, previous) {
        super(HTTP_BAD_REQUEST, message, response, previous);
        this.name = 'BadRequestError';
    }
}